module.exports = __webpack_public_path__ + "img/13.b42c5487.png";